export const TERMS_OF_SERVICE_URL = 'https://scalar.io/terms-of-service';
export const PRIVACY_POLICY_URL = 'https://scalar.io/privacy-policy';
